import Suppliers from './Suppliers'

export default Suppliers;


// WEBPACK FOOTER //
// ./src/components/Query/Suppliers/index.ts